export enum AssignmentType {
    ADVERTISEMENT = 'ADVERTISEMENT',
    MAINTENANCE = 'MAINTENANCE',
    INGREDIENTS_PURCHASES = 'INGREDIENTS_PURCHASES',
}
